import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer style={{ backgroundColor: '#333333', padding: '20px', textAlign: 'center' }}>
      <p><a href="https://www.instagram.com/rust_reduction/" target="_blank" rel="noopener noreferrer" style={{ color: '#ff4500' }}>Follow on Instagram</a></p>
    </footer>
  );
};

export default Footer;